import { styled } from "@mui/material/styles";
import { colors } from '../../theme/colors';
import { Autocomplete } from "@mui/material";
import { TextField } from "@mui/material";

export const CustomSelect = styled(Autocomplete)({
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
  },
  "& .MuiInputLabel-root": {
    color: "#919EAB",
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: colors.primary,
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: colors.primary,
      borderRadius: "10px",
    },
    "&:hover fieldset": {
      borderColor: colors.primary,
    },
    "&.Mui-focused fieldset": {
      borderColor: colors.primary,
    },
  },
  "& .MuiAutocomplete-popupIndicator": {
    color: colors.primary,
  },
  "& .MuiAutocomplete-clearIndicator": {
    color: colors.primary,
  },
  "& .css-1jy569b-MuiFormLabel-root-MuiInputLabel-root": {
    color: `${colors.primary} !important`,
    fontWeight: 600,
  },
});

export const CustomSelectField = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: colors.primary,
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: colors.primary,
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: colors.primary,
  },
});
